import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { SystemEntityGroups } from "../docSystemGroups";
import { docEntityHandleHash } from "./core/handleHash";

export function docGetEntityGroupId(doc: Pick<Doc, "entityGroups">, handle: DocEntityHandle): string | undefined {
  if (handle.type === "GROUP") {
    return handle.id;
  }

  const hash = docEntityHandleHash(handle);
  return SystemEntityGroups[hash] ?? doc.entityGroups[hash];
}
